<div id="time-cards-widget">
  @if (state.isMapInWorkbenchMode()) {
    <div class="controls">
      <i
        [title]="'MAP-DISPLAY.BUTTONS.SETTINGS' | translate"
        class="icon icon-configure_settings"
        (click)="state.showTimesWidgetConfigForm()"></i>
      @if (locations().length < 10) {
        <i [title]="'MAP-DISPLAY.BUTTONS.ADD-LOCATION' | translate" class="icon icon-add_plus_zoom-in" (click)="addLocation()"></i>
      }
    </div>
  }

  @if (locations().length) {
    <div class="time-cards-container" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)">
      @for (location of locations(); track location.uId) {
        <topo-location-time-card
          cdkDrag
          cdkDragBoundary=".locations-cards-container"
          [cdkDragDisabled]="location.uId !== selectedLocationUId()"
          [location]="location"
          [settings]="state.locationCardSettings()"
          [canEdit]="state.isMapInWorkbenchMode()"
          [isSelected]="location.uId === selectedLocationUId()"
          (onClick)="setSelectedLocation(location.uId)"
          (onRemove)="removeLocation(location.uId)"
          (onNameChange)="changeLocationName(location.uId, $event)"
          (onSetLocationFromMap)="setLocationFromMap(location.uId)"
          [style.width]="cardWidth()" />
      }
    </div>
  }
</div>
